module.exports = __webpack_public_path__ + "static/img/beiBody.9e1ac2b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/views/images/beiBody.jpg
// module id = ze8R
// module chunks = 2